import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class ExpensesCategoriesDisplayListCtrl implements IController {
  ids: any;
  isRow: any;
  rowLimit: any;
  onChange: Function;

  private expensesCategoriesRef: any;
  private displayItems: any;

  /* @ngInject */
  constructor(private $expensesCategories, private $log) {
  }

  $onInit() {
    this.expensesCategoriesRef = this.$expensesCategories();

    if (!this.rowLimit) {
      this.rowLimit = 10;
    }

    this.setItems(this.ids);
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.setItems(this.ids);
    }
  }

  onRemoveItem(id) {
    this.onChange({ids: _.filter(this.ids, (i) => {return i !== id})});
  }

  onReset() {
    this.onChange({ids: []});
  }

  private setItems(ids) {
    if (ids && ids.length) {
      this.expensesCategoriesRef.$asyncValues(ids)
        .then((expensesCategories) => {
          const displayItems = [];
          _.forEach(expensesCategories, (ec) => {
            displayItems.push({id: ec.id, value:ec.name});
          })
          this.displayItems = displayItems;
        })
        .catch((error) => {
          this.$log.error('Failed to get expenses categories', error);
        })
    } else {
      this.displayItems = [];
    }
  }



}

angular
  .module('bringoz.admin.expenses')
  .component('expensesCategoriesDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      onChange: '&'
    },
    template: require('./expenses-categories-display-list.html').default,
    controller: ExpensesCategoriesDisplayListCtrl
  });
